import { DOCUMENT } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core';
import { AppService } from '@app/app.service';
import { LANG_DICTIONARY_TOKEN } from '@constants/diConstant';
import {
    HeaderControlsComponent,
    MAP_API_SERVICE,
    MAP_DICTIONARY_TOKEN,
    MAP_NOTIFIER_SERVICE,
    REGISTRY_FRONTEND_SERVICE,
    MapComponent,
} from '@fui/map-library';
import { NotifierService } from '@services/notifier.service';
import { RegistryFrontendService } from '@submodules/map/services/registry-frontend.service';
import { ApiService } from '../../services/api.service';

/**
 * Главная страница модуля Карты 2.0
 */
@Component({
    templateUrl: './map-page.component.html',
    styleUrls: ['./map-page.component.scss'],
    imports: [HeaderControlsComponent, MapComponent],
    providers: [
        { provide: MAP_DICTIONARY_TOKEN, useExisting: LANG_DICTIONARY_TOKEN },
        { provide: MAP_NOTIFIER_SERVICE, useExisting: NotifierService },
        { provide: MAP_API_SERVICE, useClass: ApiService },
        { provide: REGISTRY_FRONTEND_SERVICE, useClass: RegistryFrontendService },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class MapPageComponent implements AfterViewInit, OnDestroy {
    private readonly document = inject(DOCUMENT);
    readonly dictionary = inject(LANG_DICTIONARY_TOKEN);
    readonly appService = inject(AppService);

    private elementList = {
        'app-header': '',
        'app-breadcrumbs': '',
    };

    /**
     * Действия после отрисовки компонента
     */
    ngAfterViewInit(): void {
        Object.keys(this.elementList).forEach((key) => this.hideElement(key));
    }

    /**
     * Действия при уничтожении компонента
     */
    ngOnDestroy(): void {
        Object.keys(this.elementList).forEach((key) => this.showElement(key));
    }

    /**
     * Скрываем стандартную панель заголовка и хлебные крошки при загрузке страницы карты
     */
    private hideElement(name: string): void {
        const elements = this.document.getElementsByTagName(name);
        if (elements.length > 0) {
            this.elementList[name] = (elements[0] as HTMLElement).style.display;
            (elements[0] as HTMLElement).style.display = 'none';
        }
    }

    /**
     * Возвращаем стандартную панель заголовка и хлебные крошки при выгрузке страницы карты
     */
    private showElement(name: string): void {
        const elements = this.document.getElementsByTagName(name);
        if (elements.length > 0) {
            (elements[0] as HTMLElement).style.display = this.elementList[name];
        }
    }
}
